import { defineStore } from 'pinia'
import state from '@/stores/intents/state'
import actionsStore from '@/stores/intents/actions'
import gettersStore from '@/stores/intents/getters'
import mutationsStore from '@/stores/intents/mutations'

export const useIntentStore = defineStore('intent', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
